// extracted by mini-css-extract-plugin
export default {"agr":"PurchasesAggregator_agr__tfAHI","search":"PurchasesAggregator_search__mEECC","registryFilterWrap":"PurchasesAggregator_registryFilterWrap__52-Mq"};